/* ==========================================================================
   AE-trading — dealerblok gelijkhouden met de afrekenknop
   Bestand: assets/ae-voordeel-sync.js
   Geladen vanuit layout/theme.liquid (defer), dus op ELKE pagina aanwezig.

   WAAROM DIT EEN APART BESTAND IS (augustus 2026)
   Deze logica stond eerst als <script> IN snippets/ae-voordeel-overzicht-b2b.liquid.
   Op de winkelwagenPAGINA werkte dat: die wordt bij het laden server-side
   gerenderd, dus het script draaide gewoon mee. In de winkelwagenLADE werkte
   het niet. De lade wordt namelijk altijd via AJAX opgehaald en met
   insertAdjacentHTML() in #CartContainer geplaatst, en de browser voert
   scripts die zo binnenkomen NIET uit. Gevolg: in de lade bleef het blok op
   de server-waarde staan (basiskorting 5%) terwijl de afrekenknop het echte
   bedrag van de B2B-app toonde (7%). Precies het verschil dat als
   "totaalprijs klopt niet" werd gemeld: blok EUR 282,66 / knop EUR 276,72.

   Nu staat de logica in een gewoon asset-bestand dat één keer wordt geladen
   en bij elke winkelwagen-update opnieuw kijkt. Het blok zelf levert alleen
   nog data (data-aevd-reg = reguliere prijs excl. btw, in centen).

   WERKING
   Bron van waarheid is het bedrag op de afrekenknop: dat is wat de klant
   daadwerkelijk betaalt. Het blok neemt dat over en leidt de korting af als
   reguliere prijs minus dat bedrag. Zo kan blok en knop niet uit elkaar
   lopen, ongeacht welk percentage in welke app staat.
   ========================================================================== */
(function () {
  'use strict';

  var POLL_MS      = 250;    // hoe vaak kijken zolang de app nog bezig is
  var MAX_WACHT_MS = 20000;  // daarna opgeven; server-waarde blijft staan
  var BTW          = 1.21;

  var timer = null;
  var observers = [];

  /* "€ 1.319,85" -> 131985 (centen). NL: punt = duizendtal, komma = decimaal. */
  function parseEuro(tekst) {
    if (!tekst) return null;
    var s = String(tekst).replace(/[^0-9.,]/g, '');
    if (!s) return null;
    s = s.replace(/\./g, '').replace(',', '.');
    var v = parseFloat(s);
    return isNaN(v) ? null : Math.round(v * 100);
  }

  function fmt(centen) {
    return '€' + (centen / 100).toLocaleString('nl-NL', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  /* Het netto totaal zoals de B2B-app het op de afrekenknop zet.
     .wcp-cart-total is het oude WPD-element; BSS herschrijft de knop en laat
     het bedrag in .cart-cost staan, met eerst de doorgestreepte adviesprijs
     en daarna het nettobedrag — vandaar de laatste match. */
  function knopBedrag(root) {
    var scope = root || document;

    var wcp = scope.querySelector('.wcp_checkout_btn .wcp-cart-total');
    var v = wcp ? parseEuro(wcp.textContent) : null;
    if (v && v > 0) return v;

    var kost = scope.querySelector('.wcp_checkout_btn .cart-cost');
    if (kost) {
      var m = kost.textContent.replace(/\s/g, '').match(/[\d.]+,\d{2}/g);
      if (m && m.length) {
        var laatste = parseEuro(m[m.length - 1]);
        if (laatste && laatste > 0) return laatste;
      }
    }
    return null;
  }

  /* De lade en de winkelwagenpagina kunnen tegelijk in de DOM staan. Zoek de
     knop het liefst binnen dezelfde container als het blok; lukt dat niet,
     dan mag de eerste knop op de pagina het zijn (zelfde winkelwagen, dus
     hetzelfde bedrag). */
  function containerVan(box) {
    return (box.closest && box.closest('#CartContainer, .cart-page, .cart')) || document;
  }

  function teken(box, netto) {
    var regulier = parseInt(box.getAttribute('data-aevd-reg'), 10);
    if (!(regulier > 0)) return;

    var voordeel = Math.max(0, regulier - netto);

    var zet = function (sel, waarde) {
      var el = box.querySelector(sel);
      if (el) el.textContent = waarde;
    };
    zet('[data-aevd-big]',  fmt(voordeel));
    zet('[data-aevd-now]',  fmt(netto));
    zet('[data-aevd-incl]', fmt(Math.round(netto * BTW)));

    var bedrag = box.querySelector('[data-aevd-korting]');
    var rij    = box.querySelector('[data-aevd-korting-row]');
    if (voordeel > 0) {
      if (bedrag) bedrag.textContent = '−' + fmt(voordeel);
      if (rij) rij.style.display = '';
    } else if (rij) {
      rij.style.display = 'none';
    }
  }

  /* Eén ronde: alle blokken bijwerken. Geeft terug of er een bedrag gevonden is. */
  function kijk() {
    var blokken = document.querySelectorAll('.aevd--b2b');
    if (!blokken.length) return false;

    var gevonden = false;
    Array.prototype.forEach.call(blokken, function (box) {
      var netto = knopBedrag(containerVan(box));
      if (!netto) netto = knopBedrag(document);
      if (!netto) return;

      gevonden = true;
      if (box.__aeLaatsteNetto === netto) return;  // niets veranderd
      box.__aeLaatsteNetto = netto;
      teken(box, netto);
    });
    return gevonden;
  }

  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
  }

  /* Wachten in plaats van gokken: blijven kijken tot de app zijn bedrag heeft
     ingevuld, daarna meekijken of het nog verandert. De observer hangt bewust
     alleen aan de afrekenknop en niet aan document.body, zodat hij niets kost. */
  function hangObservers() {
    if (!window.MutationObserver) return;
    Array.prototype.forEach.call(document.querySelectorAll('.wcp_checkout_btn'), function (knop) {
      var o = new MutationObserver(kijk);
      o.observe(knop, { childList: true, subtree: true, characterData: true });
      observers.push(o);
    });
  }

  function start() {
    stop();
    if (!document.querySelector('.aevd--b2b')) return;  // geen dealer / lege wagen

    if (kijk()) { hangObservers(); return; }

    var begin = Date.now();
    timer = setInterval(function () {
      var gevonden = kijk();
      if (gevonden || Date.now() - begin > MAX_WACHT_MS) {
        clearInterval(timer);
        timer = null;
        if (gevonden) hangObservers();
      }
    }, POLL_MS);
  }

  /* Bij elke wijziging bouwt het thema de winkelwagen opnieuw op; dan zijn
     zowel het blok als de afrekenknop nieuwe elementen. */
  document.addEventListener('theme:cart:loaded', start);
  document.addEventListener('theme:cart:initially-loaded', start);

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
